import React, {
    useEffect,
    useState,
    useLayoutEffect,
    forwardRef,
  } from 'react';
  import { Button, Checkbox, Divider, Form, Input } from 'antd';
  import styles from './Login.module.scss';
  import { Pattern } from 'shared/constants';
  import { useNavigate } from 'react-router-dom';
  import {  useAuth } from 'hooks';
  
  import smallLogo from 'assets/images/allin1logoNoText.png';
  import {
    LoadingOutlined
  } from '@ant-design/icons';
  
import { useAuthModalStore } from 'modules/zustand/store';
import { showNotification } from 'services/NotificationService';
 
  /* eslint-disable */
  interface LoginFormProps {
    email: string;
    password: string;
    remember: boolean;
  }
  
  interface LoginData {
    password: string;
    email: string;
  }

  
  const LoginModal = () => {
    const { login } = useAuth();

    const navigate = useNavigate();
   
    const [form] = Form.useForm<LoginFormProps>();
    const [formError, setFormError] = useState<string>('');
    const [pageLoading, setPageLoading ] = useState<boolean>(false);
    const [loginApiError, setLoginApiError] = useState<{
      error_code: string;
      error_message: string;
    }>();
  
    useEffect(() => {
      setFormError(loginApiError?.error_message || '');
    }, [loginApiError]);
  
    useLayoutEffect(() => {
      const getRememberUser = async () => {
        try {
          const email = await localStorage.getItem('EMAIL_REMEMBER');
          const password = await localStorage.getItem('PASSWORD_REMEMBER');
          const remember =
            (await localStorage.getItem('REMEMBER_ME')) === 'true' ? true : false;
          if (email !== null) {
            form.setFieldsValue({ email: email });
          }
          if (password !== null) {
            form.setFieldsValue({ password: password });
          }
          if (remember !== null) {
            form.setFieldsValue({ remember: remember });
          }
        } catch (error) {
          //Err
        }
      };
      getRememberUser();
    }, []);
  
    const rememberUser = async () => {
      const formData = form.getFieldsValue();
      await localStorage.setItem('EMAIL_REMEMBER', formData.email);
      await localStorage.setItem('PASSWORD_REMEMBER', formData.password);
      await localStorage.setItem('REMEMBER_ME', formData.remember.toString());
    };
  
    const onFinish = (value: LoginFormProps) => {
      setPageLoading(true)
      fetchLogin(value).then(() => {
        setPageLoading(false);
        // Optionally handle successful login here (e.g., show a notification)
      })
      .catch((error) => {
        setPageLoading(false);
        // Optionally handle error here (e.g., show an error notification)
        console.error("Login failed:", error);
      });
    };

    const setOffLoginModal = useAuthModalStore((state) => state.setOffLoginModal)
    const setOnSecureModal = useAuthModalStore((state) => state.setOnSecureModal)
    const setOnRegisterModal = useAuthModalStore((state) => state.setOnRegisterModal)
    const setOnForgotModal = useAuthModalStore((state)=>state.setOnForgotModal)
    
    const fetchLogin = async (value: LoginData) => {
      try {
        const data = await login(value.email, value.password);
        if (data.special_login_permission == true){
          setOffLoginModal()
          showNotification('', 'Login successful! Welcome to All-in-1!');
          setTimeout(() => {
            window.location.reload();
          }, 1000);
          return
        }
        setOffLoginModal();
        setOnSecureModal();
        if (form.getFieldsValue().remember) {
          rememberUser();
        } else {
          localStorage.removeItem('EMAIL_REMEMBER');
          localStorage.removeItem('PASSWORD_REMEMBER');
          localStorage.removeItem('REMEMBER_ME');
        }
      } catch (e: any) {
        if (e.error_code === 'INVALID_CREDENTIAL') {
          setLoginApiError(e);
        } else {
          setLoginApiError(undefined);
        }
      }
    };
  
    const onClickLogin = (e: any) => {
      e.preventDefault();
      // Do action submit if form pass validate fields
      form.validateFields()
      .then(() => {
        const defaultValues: LoginFormProps = {
          email: form.getFieldValue('email'),
          password: form.getFieldValue('password'),
          remember: form.getFieldValue('remember'),
        };
        
        onFinish(defaultValues);
      })
      .catch(getError);
    };
  
    const getError = () => {
      const errors = form
        .getFieldsError()
        .map((item) => item.errors)
        .reduce((prev, cur) => {
          return prev.concat(cur);
        }, []);
      setFormError(errors[0]);
    };
  
    const onClickForgotPassword = () => {
      navigate('/forgot-password');
    };
  
    return (
  
      <div className="flex flex-col justify-center items-center my-2 gap-3">
            <img style={{maxHeight:'70px'}} src={smallLogo} onClick={()=>(navigate('/'))} />
            <h1>Sign in</h1>
            <Form
              form={form}
              name="basic"
              className="flex flex-col"
              initialValues={{ remember: true }}
              // onFinish={onFinish}
              layout={'vertical'}
              size={'middle'}
              autoComplete="off"
            >
              {formError && (
                <div className="flex justify-center items-center bg-[#FFE0E0] h-[40px] mb-5">
                  {formError}
                </div>
              )}
              {/* Email */}
              <label htmlFor="email" className={styles['form-item-label']}>
                Email address: <span className="text-red-600">*</span>
              </label>
              <Form.Item
                className={styles['form-item']}
                name="email"
                rules={[
                  { required: true, message: 'Please input your email!' },
                  {
                    pattern: Pattern.EMAIL,
                    message: 'Invalid email',
                  },
                ]}
                validateTrigger={false}
              >
                <Input
                  type="email"
                  id="email"
                  className={`!w-[300px] h-[40px] !rounded-md ${
                    loginApiError ? '!border-red-500' : ''
                  }`}
                />
              </Form.Item>
              {/* Password */}
              <label htmlFor="password" className={styles['form-item-label']}>
                Password: <span className="text-red-600">*</span>
              </label>
              <Form.Item
                className={styles['form-item']}
                name="password"
                rules={[{ required: true, message: 'Please input your password!' }]}
                validateTrigger={false}
              >
                <Input.Password
                  id="password"
                  className={`!w-[300px] h-[40px] !rounded-md ${
                    loginApiError ? '!border-red-500' : ''
                  }`}
                  onPressEnter={onClickLogin}
                />
              </Form.Item>
            
              <div className='flex flex-row justify-between '>
                {/* Remember me checkbox */}
              <Form.Item
                className={styles['form-item']}
                name="remember"
                valuePropName="checked"
              >
                <Checkbox>Remember me</Checkbox>
              </Form.Item>
              {/* Forgot password */}
              <div
                
                className="underline text-black font-bold text-sm cursor-pointer m-1"
                onClick={()=>{setOffLoginModal();setOnForgotModal();}}
              >
                Forgot Password
              </div>
              </div>
              
              {/* Login */}
              <Form.Item className={styles['form-item']}>
               
                <button onClick={onClickLogin}  type="button" className="w-full flex justify-center items-center shadow mt-3 border-none text-white bg-black hover:bg-neutral-200 hover:text-black hover:shadow-md font-[450] rounded-lg text-xl py-2 text-center inline-flex items-center  mb-2 hover:-translate-y-1 transition-all duration-300" >
                  <LoadingOutlined  spin  className={`${pageLoading? '':'hidden'} text-xl mr-3`}/>Login
                </button>
              </Form.Item>
              
            <div className=" text-black text-lg m-auto">Dont have an account?</div>
            
              {/* Login */}
              <Form.Item className={styles['form-item']}>
                
                <button
                       
                  className="w-full flex justify-center items-center shadow mt-3 border-none text-black bg-neutral-200 hover:bg-neutral-300 hover:shadow-md font-[450] rounded-lg text-xl px-5 py-2 text-center inline-flex items-center  mb-2 hover:-translate-y-1 transition-all duration-300" 
                  onClick={() => {setOffLoginModal();setOnRegisterModal();}}
                >
                  Sign Up
                </button>
              </Form.Item>
              
              
              
            </Form>
          </div>
         
          
  

  
    );
  };


  
  export default LoginModal;
  